import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'formik';
import { SearchRounded } from '@mui/icons-material';

import Autocomplete from '@ui-lib/components/Inputs/Autocomplete/AsyncAutocomplete';
import { AutocompleteApiCall } from '@web-shared/api/autocomplete/types/AutocompleteApiCall';
import { BaseAutocompleteParams } from '@web-shared/api/autocomplete/types/BaseAutocompleteParams';
import { getExternalLocations } from '@web-shared/api/locations-api';

import { LocationAddressForm, LocationFormParams } from '../../../../../../../../../oh-main/web/frontend/global/modules/Locations/pages/LocationBuilder/consts';
import { FIELD_NAMES } from '../const';
import { optionsModifier } from '../../../../../../../../../oh-main/web/frontend/global/modules/Locations/shared/components/ExternalLocationsAutocomplete/utils';
import { ExternalLocationOption } from '../../../../../../../../../oh-main/web/frontend/global/modules/Locations/shared/components/ExternalLocationsAutocomplete/index';

const MapboxAutocomplete = connect<Record<string, never>, LocationFormParams>(({ formik: { setFieldValue } }) => {
  const { t } = useTranslation();

  const mapboxApiCall: AutocompleteApiCall<BaseAutocompleteParams, ExternalLocationOption> = useCallback(
    async (props) => {
      if (!props.params.query) return [];
      const locationOptions = await getExternalLocations({
        params: { address: props.params.query, limit: 10 },
        abortSignal: props.abortSignal,
      });
      return optionsModifier(locationOptions);
    },
    []
  );

  const onChange = useCallback((_event: React.SyntheticEvent, value: ExternalLocationOption | null) => {
    if (value) {
      const locationValues: LocationAddressForm = {
        address: value.label,
        latitude: value.latitude,
        longitude: value.longitude,
        city: value.city,
        country: value.country,
        state: value.state,
        street: value.street,
        zip: value.zip,
      };
      setFieldValue(FIELD_NAMES.LOCATION_ADDRESS, locationValues);
      setFieldValue(FIELD_NAMES.LOCATION_NAME, value.label);
    }

  }, [setFieldValue]);

  return <Autocomplete
    name='mapbox_location'
    label={t('inputLabel_externalLocation')}
    apiCall={mapboxApiCall}
    onChange={onChange}
    withFormik
    // @ts-expect-error: `placeholder` property does not exist in HTMLAttributes anymore
    placeholder={t('inputPlaceholder_externalLocation')}
    startAdornment={<SearchRounded />}
  />;
});

export default MapboxAutocomplete;
